export enum GiftStatus {
    Delivered = "delivered",
    Unpaid = "unpaid",
    Paid = "paid",
    Accepted = "accepted",
    Expired = "expired",
    Deleted = "deleted",
    Canceled = "canceled",
}
